export default "__VITE_ASSET__DMNq8280__"